/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import TemplateModel from 'cio/models/template';
import { isInAppRecipientDefined } from 'cio/utils/in-app/preview';
import { InAppPreview } from 'cio/utils/previews';

interface InAppContentPreviewBodyArgs {
  isRefreshing: boolean;
  preview: InAppPreview;
  template: TemplateModel;
}

export default class InAppContentPreviewBody extends Component<InAppContentPreviewBodyArgs> {
  get hasRecipientSelected() {
    let { preview } = this.args;
    return isInAppRecipientDefined(preview?.body_json) && isEmpty(preview?.errors?.to);
  }
}
